// extracted by mini-css-extract-plugin
module.exports = {"backgroundWrapper":"PlayerBackground-modulebackgroundWrapper1qp","backgroundSvg":"PlayerBackground-modulebackgroundSvg10_"};